import { useCallback, useRef, useState } from 'react'
import bracketDemoMp4 from '../assets/bracket-tutorial/mobileDemoShort.mp4'
import bracketDemoMov from '../assets/bracket-tutorial/mobileDemoShort.mov'
import demoLoadingImage from '../assets/bracket-tutorial/demoLoadingImage.png'

const SITE_URL_DISPLAY = 'primedocumentsign.com'

/**
 * Browser-window mockup (wide ~800px) with demo video — reads like primedocumentsign.com in Safari/Chrome.
 */
export function BracketTutorialPhoneDemo() {
  const videoRef = useRef(null)
  const [videoPlaying, setVideoPlaying] = useState(false)
  const [videoFailed, setVideoFailed] = useState(false)

  const tryPlay = useCallback(() => {
    const v = videoRef.current
    if (!v || videoFailed) return
    v.play().catch(() => {})
  }, [videoFailed])

  const showPoster = !videoPlaying || videoFailed

  return (
    <figure className="bracket-browser-demo" aria-label="Bracket fields demo in the browser">
      <div className="bracket-browser-demo__window">
        <div className="bracket-browser-demo__chrome bracket-browser-demo__chrome--top">
          <div className="bracket-browser-demo__traffic" aria-hidden="true">
            <span className="bracket-browser-demo__traffic-dot bracket-browser-demo__traffic-dot--red" />
            <span className="bracket-browser-demo__traffic-dot bracket-browser-demo__traffic-dot--amber" />
            <span className="bracket-browser-demo__traffic-dot bracket-browser-demo__traffic-dot--green" />
          </div>
          <div className="bracket-browser-demo__url-bar">
            <span className="bracket-browser-demo__url-lock" aria-hidden="true" title="Secure">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                <rect x="5" y="11" width="14" height="10" rx="2" />
                <path d="M8 11V8a4 4 0 0 1 8 0v3" />
              </svg>
            </span>
            <span className="bracket-browser-demo__url-text">{SITE_URL_DISPLAY}</span>
          </div>
        </div>

        <div className="bracket-browser-demo__viewport">
          <img
            className={`bracket-browser-demo__poster${showPoster ? '' : ' bracket-browser-demo__poster--hidden'}`}
            src={demoLoadingImage}
            alt=""
            width={390}
            height={844}
            decoding="async"
            fetchPriority="high"
          />
          {!videoFailed ? (
            <video
              ref={videoRef}
              className={`bracket-browser-demo__video${videoPlaying ? ' bracket-browser-demo__video--ready' : ''}`}
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
              poster={demoLoadingImage}
              aria-hidden="true"
              onPlaying={() => {
                setVideoPlaying(true)
                tryPlay()
              }}
              onLoadedData={() => {
                tryPlay()
              }}
              onCanPlay={() => {
                tryPlay()
              }}
              onError={() => {
                setVideoFailed(true)
                setVideoPlaying(false)
              }}
            >
              <source src={bracketDemoMp4} type="video/mp4" />
              <source src={bracketDemoMov} type="video/quicktime" />
            </video>
          ) : null}
        </div>

        <div className="bracket-browser-demo__chrome bracket-browser-demo__chrome--bottom" aria-hidden="true">
          <div className="bracket-browser-demo__bottom-toolbar">
            <span className="bracket-browser-demo__toolbar-btn">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </span>
            <span className="bracket-browser-demo__toolbar-btn">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 18l6-6-6-6" />
              </svg>
            </span>
            <span className="bracket-browser-demo__toolbar-spacer" />
            <span className="bracket-browser-demo__toolbar-btn">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                <polyline points="16 6 12 2 8 6" />
                <line x1="12" y1="2" x2="12" y2="15" />
              </svg>
            </span>
            <span className="bracket-browser-demo__toolbar-btn">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="3" width="7" height="7" />
                <rect x="14" y="3" width="7" height="7" />
                <rect x="14" y="14" width="7" height="7" />
                <rect x="3" y="14" width="7" height="7" />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </figure>
  )
}
